const ADD_VIDEOJS_OPTIONS = 'ADD_VIDEOJS_OPTIONS';

const INITIAL_STATE = {
  videojsOptions: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_VIDEOJS_OPTIONS:
      return {
        videojsOptions: action.payload,
      };
    default:
      return state;
  }
}

export function addVideojsOptions(videoJsOptions) {
  return {
    type: ADD_VIDEOJS_OPTIONS,
    payload: { ...videoJsOptions },
  };
}
